export var BUTTON_SIZES_MAP = {
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl',
    '2XL': '2xl',
};
export var isValidButtonSize = function (size) {
    return Object.values(BUTTON_SIZES_MAP).includes(size);
};
export var BUTTON_HIERARCHY_MAP = {
    PRIMARY: 'Primary',
    PRIMARY_DESTRUCTIVE: 'Primary destructive',
    SECONDARY_GRAY: 'Secondary gray',
    TERTIARY_COLOR: 'Tertiary color',
    SECONDARY_COLOR: 'Secondary color',
};
export var BUTTON_ICON_MAP = {
    DEFAULT: 'Default',
    LEADING: 'Leading',
    ONLY: 'Only',
};
